import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onedayschoolpicnicspotnearpune() {



    const cardData =
    {
        keyword: 'One Day School Picnic Spot Near Pune',
        heading: 'Anand Krushi Paryatan Kendra: One Day School Picnic Spot Near Pune',
        headingDescription: 'Looking for a perfect one day school picnic spot near Pune? Anand Krushi Paryatan Kendra in Morachi Chincholi offers an ideal blend of fun, safety, and rural learning just 55 km from the city. Spread across 40 acres of serene farmland, this agri-tourism center provides students with a memorable full-day experience packed with activities like bullock cart rides, tractor rides, horse riding, boating, swimming, and rain dance. The center also features engaging cultural programs such as magic shows and puppetry, along with traditional village games that foster teamwork and curiosity. With its well-organized setup and focus on hands-on experiences, Anand Krushi Paryatan Kendra is truly a top-rated destination for educational and enjoyable school outings near Pune.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "Start the picnic with guided nature walks through farmlands, ponds, and orchards. Students often spot free-roaming peacocks, parakeets, and bulbuls—great for early-morning adventures and nature photography."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Take students on fun, bumpy rides across village tracks in decorated bullock carts and farm tractors. This rural experience is both entertaining and educational, offering insight into village transport heritage."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open playgrounds. These energy-packed activities promote teamwork, physical fitness, and joyful interaction among students."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Teachers can lead hands-on stations where students plant seeds, water saplings, create compost pits, and learn about seasonal crops and organic farming—all guided by local farmers."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "Visit the farm’s dairy section where students can feed calves, milking demonstration sessions, and observe goats and ducks—a wonderful way to learn about farm animals and their care."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up creative corners for clay pottery, diya painting, and leaf-print crafts. These activity sessions help students explore their artistic side and take home handmade souvenirs."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Serve wholesome Maharashtrian-style meals—breakfast (poha, upma), unlimited thali lunch on banana leaves, and evening snacks. Meals are cooked fresh, healthy, and kid-friendly."
  },
  {
    "title": "Rain Dance & Splash Zone",
    "description": "Cool off after afternoon sessions with fun rain dance and splash pool time. DJ-backed music and safe pool areas make this a favorite for summer trips and enthusiastic kids."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Students enjoy engaging puppet shows, magic acts, or folk storytelling sessions in a shaded outdoor space—combining laughter, culture, and entertainment."
  },
  {
    "title": "Group Photo Spots & Return Gifts",
    "description": "End the day with a group photo under iconic village backdrops—like bullock carts or peacock trails. Students also receive small take-home tokens like clay tokens or seed packets."
  }
],




"services": [
  {
    "name": "Best School-Friendly Spot in Morachi Chincholi",
    "description": "Secure, spacious and scenic—designed specifically for school excursions, with easy access, buffer zones, and group-friendly organisation."
  },
  {
    "name": "Farm-Based Education Trip",
    "description": "Hands-on farm tours where students learn crop cycles, composting, irrigation practices, and seasonal harvest techniques alongside instructors."
  },
  {
    "name": "Safe Playgrounds for Students",
    "description": "Fenced, age-segregated play areas with slides, swings and soft-flooring to ensure students have fun in a safe environment."
  },
  {
    "name": "Fun Animal Interaction Zones",
    "description": "Pet farms featuring goats, rabbits, ducks, and chickens—supervised interactions that let children learn about animal care in real time."
  },
  {
    "name": "Interactive Farming Demos",
    "description": "Guided sessions where kids participate in sowing, weeding, harvesting, and planting while understanding ecological concepts."
  },
  {
    "name": "Cultural Exposure for Kids",
    "description": "Folk music, traditional dance, storytelling, and local crafts—designed to introduce students to rural Maharashtrian culture."
  },
  {
    "name": "Group Lunch Zones",
    "description": "Designated dining spaces with benches, shade, and sanitation, serving hygienic vegetarian meals made from farm-fresh produce."
  },
  {
    "name": "Clean Toilets and Hygiene Maintained",
    "description": "Regularly cleaned washrooms, hand-washing stations, and water availability to ensure student well-being throughout the visit."
  },
  {
    "name": "Games and Nature Activities for Children",
    "description": "Curated outdoor games—relay races, treasure hunts, bird-spotting walks—blending recreation and environmental learning."
  },
  {
    "name": "Learning via Nature Sessions",
    "description": "Mini science sessions in the open—covering plant and insect anatomy, local ecology, tree identification, and sustainability themes."
  },
  {
    "name": "On-Site Guides and Support Staff",
    "description": "Trained facilitators with ideal student–staff ratios who ensure safety and enhance learning during all activities."
  },
  {
    "name": "Special School Packages Available",
    "description": "Customised school programs with schedule flexibility, learning targets, meals, snacks, and transport/logistics support."
  },
  {
    "name": "Booking and Travel Help",
    "description": "Simple online booking system, transport coordination (bus/van), permission letters, and real-time assistance for group leaders."
  },
  {
    "name": "Relaxing and Fun Environment for Students",
    "description": "A balanced environment of fields, shade, and quiet corners—designed to refresh students while engaging them mentally and physically."
  },
  {
    "name": "Age‑Appropriate Games and Shows",
    "description": "Tailored activities matched to age groups—puppet shows, folk skits for little kids, and adventure games for older students."
  },
  {
    "name": "Bird-Watching and Bullock Cart Rides for Students",
    "description": "Students can enjoy peaceful bird-watching walks with guides and experience traditional bullock cart rides that offer cultural and environmental learning combined with fun."
  }
],
"tableData": [
  ["Best School-Friendly Spot in Morachi Chincholi", "Farm-Based Education Trip"],
  ["Safe Playgrounds for Students", "Fun Animal Interaction Zones"],
  ["Interactive Farming Demos", "Cultural Exposure for Kids"],
  ["Group Lunch Zones", "Clean Toilets and Hygiene Maintained"],
  ["Games and Nature Activities for Children", "Learning via Nature Sessions"],
  ["On-Site Guides and Support Staff", "Special School Packages Available"],
  ["Booking and Travel Help", "Relaxing and Fun Environment for Students"],
  ["Age‑Appropriate Games and Shows", "Bird-Watching and Bullock Cart Rides for Students"]
],



"whychoose": [
  {
    "WhyChooseheading": "Perfect One-Day School Picnic Destination",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra is an ideal one-day school picnic spot near Pune, offering a well-planned itinerary filled with fun and learning, just a short drive away from the city."
  },
  {
    "WhyChooseheading": "Interactive Learning Through Nature",
    "WhyChoosedescription": "Students explore nature through guided farm tours, bird watching, and organic farming experiences, making the day both educational and engaging."
  },
  {
    "WhyChooseheading": "Fun and Safe Outdoor Adventures",
    "WhyChoosedescription": "Children can enjoy safe outdoor adventures such as bullock cart rides, zip-lining, rope climbing, and tractor tours, all supervised by trained staff."
  },
  {
    "WhyChooseheading": "Nutritious and Delicious Local Meals",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra serves freshly prepared Maharashtrian meals using farm-grown ingredients, providing both taste and health benefits."
  },
  {
    "WhyChooseheading": "Eco-Conscious and Clean Environment",
    "WhyChoosedescription": "Set in a serene, pollution-free rural landscape, the center offers a peaceful and clean environment that encourages relaxation and environmental awareness."
  },
  {
    "WhyChooseheading": "Easily Accessible from Pune",
    "WhyChoosedescription": "Located just around 50 km from Pune, it’s the perfect quick getaway for schools seeking a blend of recreation, education, and cultural exposure."
  }
]































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Anand Krushi Paryatan Kendra a popular school picnic spot near Pune?',
    answer: 'Anand Krushi Paryatan Kendra is popular for its authentic rural experience combined with fun-filled educational activities. Surrounded by nature, it offers students a safe, refreshing break from classroom learning.',
  },
  {
    id: 'FAQ2',
    question: 'What activities are available for students at Anand Krushi Paryatan Kendra?',
    answer: 'Students can enjoy bullock cart rides, tractor rides, rain dance, swimming pool, farm visits, nature trails, and traditional games, all in a safe and supervised environment.',
  },
  {
    id: 'FAQ3',
    question: 'Are meals provided during school picnic packages?',
    answer: 'Yes, the picnic packages include freshly cooked, healthy Maharashtrian vegetarian meals – typically breakfast, lunch, and evening snacks made from locally sourced ingredients.',
  },
  {
    id: 'FAQ4',
    question: 'Is Anand Krushi Paryatan Kendra safe for school children?',
    answer: 'Absolutely. The center maintains child safety as a priority with trained staff, designated play areas, first-aid facilities, and continuous supervision.',
  },
  {
    id: 'FAQ5',
    question: 'How far is Anand Krushi Paryatan Kendra from Pune and Pimpri-Chinchwad?',
    answer: 'It is located approximately 60-70 km from Pune and Pimpri-Chinchwad, easily reachable within 1.5 to 2 hours by private or school-arranged transport.',
  },
  {
    id: 'FAQ6',
    question: 'Can large school groups be accommodated?',
    answer: 'Yes, Anand Krushi Paryatan Kendra is well-equipped to host large school groups, offering ample space, activity zones, and age-appropriate experiences.',
  },
  {
    id: 'FAQ7',
    question: 'What is the typical duration of a school picnic at Anand Krushi Paryatan Kendra?',
    answer: 'School picnics are generally scheduled for a full day, usually from 9:30 AM to 5:30 PM, with a balanced mix of activities, meals, rest, and recreation.',
  },
  {
    id: 'FAQ8',
    question: 'Are there facilities for rest and shade during the picnic?',
    answer: 'Yes, the premises have shaded seating areas, rest zones, clean washrooms, and drinking water stations for comfort and convenience.',
  },
  {
    id: 'FAQ9',
    question: 'Is prior booking required for school picnics at Anand Krushi Paryatan Kendra?',
    answer: 'Yes, schools are advised to book their visits at least 2-3 weeks in advance, especially during the busy school outing season.',
  },
  {
    id: 'FAQ10',
    question: 'How can schools arrange transport to Anand Krushi Paryatan Kendra?',
    answer: 'Schools can either use their own buses or coordinate with the Kendra for transport support. The staff can assist in arranging reliable bus services on request.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Sunita Joshi, School Teacher, Pune',
    feedback: "Anand Krushi Paryatan Kendra gave our students a perfect mix of fun and learning. The kids loved the outdoor games and rain dance. Very well organized!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Sandeep Patil, Principal, PCMC',
    feedback: "A peaceful and safe destination for school trips. The food was delicious, and the staff ensured every child was taken care of. Highly recommended for day picnics!",
    rating: 5,
  },
];




































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const oneDaySchoolPicnicSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOccupationalProgram",
  "name": "One Day School Picnic Spot Near Pune",
  "educationalProgramMode": "OnSite",
  "description": "Ideal one-day school picnic spot near Pune offering farm-based educational activities, nature exploration, bird watching, bullock cart rides, and guided farming sessions for students.",
  "provider": {
    "@type": "Organization",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "programPrerequisites": "For school groups only, prior reservation required",
  "hasCourse": [
    {
      "@type": "Course",
      "name": "Agro-Farm Experience",
      "description": "Interactive farming demo, animal interaction, and rural education."
    },
    {
      "@type": "Course",
      "name": "Eco & Cultural Learning",
      "description": "Bird watching, cultural performances, and eco-tourism activities."
    }
  ],
  "url": "https://morachichincholi.in/one-day-school-picnic"
};




    return (
        <div>
<Helmet>
  <title>One Day School Picnic Spot Near Pune | Educational Farm Activities for Students</title>
  <meta 
    name="description" 
    content="Visit Anand Krushi Paryatan Kendra for a one-day school picnic near Pune. Safe and fun farm-based educational activities including nature trails, bullock cart rides, bird watching, and student-friendly outdoor games." 
  />
  <meta 
    name="keywords" 
    content="Educational picnic locations near Pune, Safe picnic spots for school students, Nature-based learning experiences, Farm visit with kids’ activities, One day trip for school near Pune, Budget-friendly school picnic packages, Fun & learning combo spots, School picnic with adventure games, Cultural exposure locations for students, School-friendly resorts near Pune, Agro-tourism for school groups, Outdoor team-building games for kids, Farm activities with guides, Best farm for school groups, Bird-watching and bullock cart rides for students" 
  />
  <script type="application/ld+json">
    {JSON.stringify(oneDaySchoolPicnicSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onedayschoolpicnicspotnearpune;